import {
    type ApproveAccountDeletionRequestResponseType,
    type ApproveAccountDeletionRequestRequestType
} from "./type";
import {
    request
} from "../request";

const approveAccountDeletionRequest = async (
    params: ApproveAccountDeletionRequestRequestType
): Promise<ApproveAccountDeletionRequestResponseType> => {
    return await request<ApproveAccountDeletionRequestResponseType>(
        "/request/approveAccountDeletionRequest",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default approveAccountDeletionRequest;
